import type { LoadingVisualAnimationType } from '@/components/ui/loading-visual';
import type { BrandAssetSource } from '@/lib/branding/resolveBrandAwareLoading';

/** Unified default title — align DOM, loading block, and useBrand. */
export const DEFAULT_BRAND_TITLE = 'ISOFH System Management';

export interface LoadingBlockConfig {
  title: string | null;
  brandAssetUrl: string | null;
  brandAssetSource: BrandAssetSource;
  loadingType: LoadingVisualAnimationType;
  loadingSpeedMs: number;
  animationsEnabled: boolean;
  configSource: 'site_settings' | 'public_bootstrap' | 'fallback' | 'draft';
}

export const FALLBACK_LOADING_BLOCK: LoadingBlockConfig = {
  title: null,
  brandAssetUrl: null,
  brandAssetSource: 'none',
  loadingType: 'default',
  loadingSpeedMs: 1000,
  animationsEnabled: true,
  configSource: 'fallback',
};

/** Mirror for pre-React boot — must stay aligned with FALLBACK_LOADING_BLOCK. */
export const FALLBACK_SERIALIZED_LOADING_BLOCK = {
  title: FALLBACK_LOADING_BLOCK.title,
  brandAssetUrl: FALLBACK_LOADING_BLOCK.brandAssetUrl,
  brandAssetSource: FALLBACK_LOADING_BLOCK.brandAssetSource,
  loadingType: FALLBACK_LOADING_BLOCK.loadingType,
  loadingSpeedMs: FALLBACK_LOADING_BLOCK.loadingSpeedMs,
  animationsEnabled: FALLBACK_LOADING_BLOCK.animationsEnabled,
  configSource: 'fallback' as const,
};
